module.exports = __webpack_public_path__ + "img/ics_f_clock2_orange.5a4cdcf1.svg";